export default __webpack_public_path__ + "static/media/arrow-right-quick-game.732b9aaf.svg";